import { safeGet } from '../../core/utils/safe-get.js';
import { AreaDisplay } from '../components/displays/AreaDisplay.js';
import { BarDisplay } from '../components/displays/BarDisplay/BarDisplay.js';
import { DotDisplay } from '../components/displays/DotDisplay.js';
import { LineDisplay } from '../components/displays/LineDisplay.js';
import type { AxisIdToScales } from '../context/XYChartScales.context.js';
import {
  AREA_VARIANT,
  type AreaMetadata,
  type AreaSeriesWithDatapoints,
  BAR_VARIANT,
  type BarMetadata,
  type BarSeriesWithDatapoints,
  DOT_VARIANT,
  type DotMetadata,
  type DotSeriesWithDatapoints,
  LINE_VARIANT,
  type LineMetadata,
  type LineSeriesWithDatapoints,
  type SeriesToMetadata,
  type XYChartSeriesWithDatapoints,
} from '../types/xy-chart-internals.js';

interface SeriesDisplayProps {
  series: XYChartSeriesWithDatapoints;
  axisIdToScales: AxisIdToScales;
  seriesToMetadata: SeriesToMetadata;
}

export function XYChartShiftedDisplay({
  series,
  axisIdToScales,
  seriesToMetadata,
}: Readonly<SeriesDisplayProps>) {
  switch (series.type) {
    case DOT_VARIANT:
      return (
        <DotDisplay
          key={series.id}
          axisIdToScales={axisIdToScales}
          series={series}
          metadata={safeGet<DotSeriesWithDatapoints, DotMetadata>(
            seriesToMetadata,
            series,
          )}
        />
      );
    case LINE_VARIANT:
      return (
        <LineDisplay
          key={series.id}
          axisIdToScales={axisIdToScales}
          series={series}
          metadata={safeGet<LineSeriesWithDatapoints, LineMetadata>(
            seriesToMetadata,
            series,
          )}
        />
      );
    case BAR_VARIANT:
      return (
        <BarDisplay
          key={series.id}
          axisIdToScales={axisIdToScales}
          series={series}
          metadata={safeGet<BarSeriesWithDatapoints, BarMetadata>(
            seriesToMetadata,
            series,
          )}
        />
      );
    case AREA_VARIANT:
      return (
        <AreaDisplay
          key={series.id}
          axisIdToScales={axisIdToScales}
          series={series}
          metadata={safeGet<AreaSeriesWithDatapoints, AreaMetadata>(
            seriesToMetadata,
            series,
          )}
        />
      );
    default:
      return null;
  }
}
